import React from 'react';
import AssetsLibraryUtilities from './AssetsLibraryUtilities';
import AssetsManager from '../../classes/AssetsManager';
import Dialog from '../layout/Dialog';
import BoolProperty from '../properties/BoolProperty';
import Spacer from '../layout/Spacer';
import Panel from '../layout/Panel';
import { useTypedDispatch, useTypedSelector } from '../../state/hooks';
import { StoreActions } from '../../state/store';
import { AssetSubTrees } from '../../interfaces/AssetLibrary';

export default function DeleteAssetDialog(props)
{
	const dispatch = useTypedDispatch();

	const showDialog = useTypedSelector(state => state.preferencesModule.editorPreferences.enableDialogDeleteAsset);

	const assetProps = AssetsManager.getPropsForAsset(props.assetIds[0]); // TODO: multiple assets selected
	if(!assetProps)
	{
		console.error("DeleteAssetDialog: asset props not found for asset id", props.assetIds[0]);
		if(props.onShutDown) props.onShutDown();
		return null;
	}

	function generateDialogMessage()
	{
		if(!assetProps) return "Missing Asset Info!";

		const output = new Array<JSX.Element>();
		switch(assetProps.tag)
		{
			case AssetSubTrees.User:
				output.push(<p>Deleting <b>{assetProps.label}</b> will delete it from your Personal Assets folder for all projects.</p>);
				output.push(<p className={"warningText"}>This action cannot be undone</p>);
				break;
			case AssetSubTrees.Organization:
				output.push(<p>Deleting <b>{assetProps.label}</b> will delete it from your Company Assets folder for all users.</p>);
				output.push(<p className={"warningText"}>This action cannot be undone</p>);
				break;
			case AssetSubTrees.Project:
				output.push(<p>Deleting <b>{assetProps.label}</b> will delete it from the current project. It will still be available on other projects.</p>);
				break;
		}
		
		output.push(<p>Delete asset?</p>);
		return output;
	}

	return (
		<Dialog data-name={"delete-asset-dialog"}
			onShutdown={props.onShutdown}
			title={"Delete Asset"}
			actions={[
				{
					label: "Confirm",
					onClick: () =>
					{
						AssetsLibraryUtilities.deleteAsset(assetProps);
					},
				},
				{
					label: "Cancel",
				}
			]}
		>
			<Panel size={{ x: "300px" }}
				className={"no-overflow"}
			>
				{ generateDialogMessage() }
				<Spacer size={{ y: "10px" }} />
				<BoolProperty data-name={"delete-asset-dont-ask-again"}
					labelAfterProperty={"Don't ask again"}
					labelClass={"propertyLabelFit"}
					value={!showDialog}
					onChangeCallback={(v: boolean) => 
					{
						dispatch(StoreActions.preferences.setEditorPreferences({ enableDialogDeleteAsset: !v }));
					}}
				/>
			</Panel>
		</Dialog>
	);
}